import { Button } from "@z/ui";

/** Section 7 multi-tab policy: one tab owns the database. */
export function HeldByOtherTab(props: { lost?: boolean; onTakeOver?: () => Promise<void> }) {
  return (
    <div className="flex h-full items-center justify-center bg-bg p-6 text-fg">
      <div className="max-w-sm space-y-3 text-center">
        <h1 className="text-lg font-semibold">
          {props.lost ? "This tab was closed by another tab" : "Already open in another tab"}
        </h1>
        <p className="text-fg-muted text-sm">
          HQ keeps its local database open in one tab at a time so your notes are never written from
          two places at once.
        </p>
        {props.onTakeOver ? (
          <Button onClick={() => void props.onTakeOver?.()}>Use here instead</Button>
        ) : (
          <Button variant="secondary" onClick={() => location.reload()}>
            Reload
          </Button>
        )}
      </div>
    </div>
  );
}
